var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.62132034,8.32842712 L4.3890873,10.0961941 L3.32842712,11.1568542 L0.5,8.32842712 L3.32842712,5.5 L4.3890873,6.56066017 L2.62132034,8.32842712 Z M13.4105339,8.32842712 L11.642767,6.56066017 L12.7034271,5.5 L15.5318542,8.32842712 L12.7034271,11.1568542 L11.642767,10.0961941 L13.4105339,8.32842712 Z M8.75123799,3.98471441 L10.1607769,4.49774462 L7.42461578,12.0152856 L6.01507684,11.5022554 L8.75123799,3.98471441 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbed);
export default __webpack_public_path__ + "static/media/embed.bbf7cbea65006f9c3ef3914b9164e7ad.svg";
export { ForwardRef as ReactComponent };